"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBanners = getBanners;
exports.getBannersBottom = getBannersBottom;
exports.getBannersMiddle = getBannersMiddle;
exports.getBannersQuickBooking = getBannersQuickBooking;
exports.getBannersTop = getBannersTop;
exports.getBannersWeb = getBannersWeb;
exports.getHomeScreenBanners = getHomeScreenBanners;
exports.getOrderAppointmentList = getOrderAppointmentList;
exports.getRxPreorder = getRxPreorder;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function getBanners(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getRxPreorder(tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}user-common-service/rxpreorder`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getBannersTop(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_TOP;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getBannersMiddle(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_MIDDLE;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getBannersBottom(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_BOTTOM;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getBannersQuickBooking(tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_QUICKBOOKING;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getOrderAppointmentList(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.ASTER_APPOINTMENT_ORDER}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getBannersWeb(bannerId, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOME_BANNER_WEB + bannerId;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
/**
 * This is common api for all modules(ASCO/AT/AE) banners
 * @param {homePageType=ASCO/AT/AE} requestParams
 * @returns Sets of banners
 */
function getHomeScreenBanners(requestParams, tokenData) {
  let queryString = '?';
  for (const key in requestParams) {
    if (queryString === '?') {
      queryString = queryString + key + '=' + requestParams[key];
    } else {
      queryString = queryString + '&' + key + '=' + requestParams[key];
    }
  }
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.HOME_SCREEN_BANNER}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}